import { render } from "./ClientTaskDrawer.vue?vue&type=template&id=61d77508&scoped=true"
import script from "./ClientTaskDrawer.vue?vue&type=script&lang=js"
export * from "./ClientTaskDrawer.vue?vue&type=script&lang=js"

import "./ClientTaskDrawer.vue?vue&type=style&index=0&id=61d77508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d77508"]])

export default __exports__